import { defineStore } from 'pinia'
import { driverMineApi } from '@/service/api/driver/mine'

export const useDriverMineStore = defineStore({
  id: 'driverMine',
  state: () => ({
    fleetCarList: [],
    fleetCarTotal: 0,
    fleetCarTypeTotal: {},
    vehicleDetail: {},
    expenseTypeList: [{}],
    fundMode: {},
    maxSingleSettingAmount: '',
    checkFirst: true,
    recommendFleetInfo: {},
    openCityList: [],
    recomDriverList: [],
    recomOmegaData: {},
    recomDriverTotal: 0,
    // 初始值是空的 不展示简历信息
    recommendDriverResume: null,
    centerDriverDetail: {},
    centerDriverMapUrl: '',

    pickAddressList: [],
    pickAddressDetail: {},
    pickAddressIsCompletePoi: false,
    searchPickAddressList: [],
    searchPickAddressTotal: 0,
    reverseAddressDetail: {},

    deleteAddressFlag: false,
  }),
  // getters: {
  //   testLength: (state) => state.test.length,
  // },
  actions: {
    async insertPost() {
    },
    async uploadFleetPortrait(params: any) {
      const { data } = await driverMineApi.uploadFleetPortrait(params)
      return data
    },
    async getFleetCarList(params: any) {
      if (params?.page_no === 1) {
        this.fleetCarList = []
        this.fleetCarTotal = 0
      }
      const { data } = await driverMineApi.getCarList(params)
      this.fleetCarList = data?.page_data?.page_no === 1
        ? data?.list || []
        : [...this.fleetCarList, ...data?.list || []]
      this.fleetCarTotal = data?.page_data?.count || 0
    },
    async getFleetCatTypeTotal(params: any) {
      const { data } = await driverMineApi.getCarTypeTotal(params)
      this.fleetCarTypeTotal = data || {}
    },
    async uploadSignPicture(params: any) {
      return await driverMineApi.uploadSignPicture(params)
    },
    async putVehicleOnSelf(params: any) {
      await driverMineApi.putVehicleOnSelf(params)
    },
    async getVehicleDetail(params: any) {
      const { data } = await driverMineApi.getVehicleDetail(params)
      this.vehicleDetail = data
    },
    async rentConfig(params: any) {
      const { data } = await driverMineApi.rentConfig(params);
      this.expenseTypeList = data.map(item => {
        return {
          text: item.title,
          value: item.sub_bill_type,
          is_other: item.is_other
        }
      })
    },
    async getFundMode(params: any) {
      const { data } = await driverMineApi.getFundMode(params)  // 1=normal模式; 2=offline模式
      this.fundMode = data;
      // this.fundMode = {
      //   fund_mode: 2,
      //   is_set: true,
      //   switch: true
      // };
    },
    async changeFundMode(params: any) {
      const { data } = await driverMineApi.changeFundMode(params)
      return data
    },
    async getMaxSettingAmount(params: any) {
      const { data } = await driverMineApi.getMaxSettingAmount(params)  // 1=normal模式; 2=offline模式
      this.maxSingleSettingAmount = data.max_single_setting_amount;
    },
    async checkDriverEdited(params: any) {
      const { data } = await driverMineApi.checkDriverEdited(params)
      this.checkFirst = data === 0
    },
    async getRecommendFleetInfo(params: any) {
      const { data } = await driverMineApi.getRecommendFleetInfo(params)
      this.recommendFleetInfo = data
    },
    async saveRecommendFleetInfo(params: any) {
      await driverMineApi.saveRecommendFleetInfo(params)
    },
    async getOpenCityList(params: any) {
      const { data } = await driverMineApi.getOpenCityList({
        ...params,
        choice: 1,
      })
      this.openCityList = data?.open_cities || []
    },
    async putCarOffShelf(params: any) {
      await driverMineApi.putCarOffShelf(params)
    },
    async getRecomDriverList(params: any) {
      const { data } = await driverMineApi.getRecomDriverList(params)
      this.recomDriverList = data?.page === 1
        ? data?.driver_list || []
        : [...this.recomDriverList, ...data?.driver_list || []]
      this.recomDriverTotal = data?.total || 0
      this.recomOmegaData = data?.omega_data || {}
    },
    async getCenterDriverDetail(params: any) {
      const { data } = await driverMineApi.getCenterDriverDetail(params)
      this.centerDriverDetail = data
    },
    async getCenterDriverMapUrl(params: any) {
      const { data } = await driverMineApi.getCenterDriverMapUrl(params)
      this.centerDriverMapUrl = data?.map_url || ''
    },
    async getRecommendDriverResume(params: any) {
      const { data } = await driverMineApi.getRecommendDriverResume(params)
      this.recommendDriverResume = data
    },
    async markDriver(params: any) {
      await driverMineApi.markDriver(params)
    },
    async getVirtualPhone(params: any) {
      const { data } = await driverMineApi.getVirtualPhone(params)
      return data
    },
    async getVehicleStatus(params: any) {
      await driverMineApi.getVehicleStatus(params)
    },

    async getPickAddressList(params: any) {
      const { data } = await driverMineApi.getPickAddressList(params)
      this.pickAddressList = data || []
    },
    async searchPickAddress(params: any) {
      const { data } = await driverMineApi.searchPickAddress(params)
      this.pickAddressIsCompletePoi = data?.is_complete_poi === 1
      this.searchPickAddressList = data?.addressList || []
      this.searchPickAddressTotal = 0
    },
    async getPickAddressDetail(params: any) {
      const { data } = await driverMineApi.getPickAddressDetail(params)
      this.pickAddressDetail = data || {}
    },
    async getReverseAddress(params: any) {
      const { data } = await driverMineApi.getReverseAddress(params)
      this.reverseAddressDetail = data || {}
    },
    async savePickAddress(params: any) {
      await driverMineApi.savePickAddress(params)
    },
    async deletePickAddress(params: any) {
      await driverMineApi.deletePickAddress(params)
    },
  },
})
